import React from "react";
import { Flex, Heading, Button } from "@radix-ui/themes";

const PodcastsView = ({ isMine }) => {
  return (
    <div>
      <Flex align="center" justify="between" mb="5">
        {isMine ? (
          <Heading as="h3" size="4" trim="both">
            Your audios
          </Heading>
        ) : (
          <Heading as="h3" size="4" trim="both">
            Saved podcasts
          </Heading>
        )}
        {/* <Flex my="-1" gap="4">
          <Button size="2" variant="outline">
            Sort
          </Button>
        </Flex> */}
      </Flex>

      <Flex direction="column" gap="4"></Flex>
    </div>
  );
};

export default PodcastsView;
